import React from "react";

const SchoolYearBadge: React.FC<{
  children?: React.ReactNode;
  tone?: "current" | "archive";
}> = ({ children, tone = "current" }) => (
  <span
    className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${
      tone === "archive"
        ? "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300"
        : "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-100"
    }`}
  >
    {children}
  </span>
);

export default SchoolYearBadge;
